import ProductTitlePresenter from "../components/product-title/presenter/product-title";

const productTitleElement = document.querySelector(`.product-wrapper`);
const productTitleComponent = new ProductTitlePresenter(productTitleElement);
productTitleComponent.init();
